/* custom-search-results.js: "Show more" on the search results page (sections/custom-search-results.liquid;
   CHANGES.md "Search results page"). The button is a real link to the next page; here it fetches that page
   through the Section Rendering API and appends its cards to the grid: cards that the fetched page lists
   before its own "Also mentions" heading (title matches) go in front of the existing heading, the rest go
   at the end, the heading is kept only when the page had none. The next button replaces the current one,
   the progress line is recomputed from what is on screen, a polite live region announces it, focus moves
   to the first card added at the end. The address bar is left alone, so a reload or Back returns to the
   first page with Show more intact. Delegated on document, so it survives theme.Collection's AJAX
   re-render of #CollectionAjaxContent after a filter change. Modifier clicks and any failure fall back
   to following the link. */
(function () {
  'use strict';

  function fill(template, values) {
    return Object.keys(values).reduce(function (text, key) {
      return text.split('{' + key + '}').join(String(values[key]));
    }, template || '');
  }

  /* the review counts of the row layout: the Liquid prints the raw integer, the locale adds the separators */
  function formatCounts(scope) {
    var nodes = scope.querySelectorAll('[data-count]');
    for (var i = 0; i < nodes.length; i++) {
      var n = Number(nodes[i].getAttribute('data-count'));
      if (!isNaN(n)) nodes[i].textContent = '(' + n.toLocaleString('en-GB') + ')';
    }
  }
  function formatAll() {
    var root = document.querySelector('[data-section-type="collection-template"].wg-search');
    if (root) formatCounts(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', formatAll);
  else formatAll();
  document.addEventListener('collection:reloaded', formatAll);

  function appendPage(link) {
    var root = link.closest('[data-section-type="collection-template"]');
    var items = root && root.querySelector('[data-search-items]');
    var moreWrap = link.closest('[data-search-more]');
    if (!root || !items || !moreWrap || !window.fetch || !window.DOMParser) return false;

    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));
    link.setAttribute('aria-busy', 'true');

    fetch(url.toString(), { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('search page ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelector('[data-search-items]');
        var newMore = doc.querySelector('[data-search-more]');
        if (!newItems) throw new Error('no items in the next page');

        var existingAlso = items.querySelector('[data-search-also]');
        var fetched = Array.prototype.slice.call(newItems.children);
        var fetchedAlsoIndex = fetched.findIndex(function (el) { return el.hasAttribute('data-search-also'); });
        var before = fetchedAlsoIndex > -1 ? fetched.slice(0, fetchedAlsoIndex) : [];
        var after = fetchedAlsoIndex > -1 ? fetched.slice(fetchedAlsoIndex + 1) : fetched;
        var fetchedAlso = fetchedAlsoIndex > -1 ? fetched[fetchedAlsoIndex] : null;

        var reveal = function (el) {
          el.querySelectorAll('[data-aos]').forEach(function (animated) { animated.classList.add('aos-animate'); });
          if (el.hasAttribute('data-aos')) el.classList.add('aos-animate');
        };

        /* title matches of the fetched page join the title matches already on screen */
        before.forEach(function (el) {
          reveal(el);
          if (existingAlso) items.insertBefore(el, existingAlso); else items.appendChild(el);
        });
        if (fetchedAlso && !existingAlso && after.length) {
          items.appendChild(fetchedAlso);
        }
        var first = null;
        after.forEach(function (el) {
          reveal(el);
          if (!first) first = el;
          items.appendChild(el);
        });
        if (!first && before.length) first = before[0];

        if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
          window.theme.reinitProductGridItem();
        } else if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        }

        var total = parseInt(moreWrap.getAttribute('data-search-total'), 10) || 0;
        var progressTemplate = moreWrap.getAttribute('data-progress-template') || '';
        var moreTemplate = moreWrap.getAttribute('data-more-template') || '';
        var shown = items.querySelectorAll('.grid-product, [data-search-card]').length;
        formatCounts(items);
        var remaining = Math.max(total - shown, 0);

        var nextLink = newMore && newMore.querySelector('[data-search-more-link]');
        if (nextLink && remaining > 0) {
          nextLink.textContent = fill(moreTemplate, { count: remaining });
          nextLink.setAttribute('data-remaining', String(remaining));
          link.replaceWith(nextLink);
        } else {
          link.remove();
        }
        var progress = moreWrap.querySelector('[data-search-progress]');
        if (progress) progress.textContent = fill(progressTemplate, { shown: shown, total: total });

        var live = root.querySelector('[data-search-more-live]');
        if (live && progress) live.textContent = progress.textContent;

        var focusTarget = first && first.querySelector('a');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      })
      .catch(function () {
        window.location.href = link.href;
      });
    return true;
  }

  /* After theme.Collection re-renders #CollectionAjaxContent (a filter change), a Rebuy placeholder in the
     empty state is new DOM: ask Rebuy to initialise it. */
  document.addEventListener('collection:reloaded', function () {
    if (!document.querySelector('[data-search-rebuy] [data-rebuy-id]')) return;
    if (window.Rebuy && typeof window.Rebuy.init === 'function') window.Rebuy.init();
  });

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-search-more-link]');
    if (!link) return;
    if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
    if (link.getAttribute('aria-busy') === 'true') {
      evt.preventDefault();
      return;
    }
    if (appendPage(link)) evt.preventDefault();
  });
})();
